export { SectionHeading, type SectionHeadingProps } from './SectionHeading';
